<template>

  <v-dialog class="dialog" v-model="isActive" max-width="420">
    <v-card>
      <v-card-title class="headline text">{{ title }}</v-card-title>
      <v-card-text class="text">{{ text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed="depressed" @click="cancel">{{ cancelButtonText }}</v-btn>
        <v-btn depressed="depressed" @click="confirm">{{ confirmButtonText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>

export default {
  name: 'ConfirmPopup',
  props: [
    'isActive',
    'title',
    'text',
    'cancelButtonText',
    'confirmButtonText'
  ],
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    confirm () {
      this.$emit('confirm')
    }
  }
}

</script>

<style lang="scss" scoped>

  .text {
    white-space: pre-line;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/ConfirmPopup.vue